import { css } from "@emotion/react";
import { theme } from "@xometry/xometry_loft";

export const modalFiles = css`
  margin-top: ${theme.space[3]};
  padding: ${theme.space[2]} 0 ${theme.space[2]};
`;
